import { SettingsKey } from "@prisma/client";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import prisma from "./prisma-client";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/*export async function getSetting(key: SettingsKey) {
  const setting = await prisma.settings.findUnique({
    where: { key },
  });
  return setting!.value;
}*/

export async function getSetting(key: SettingsKey): Promise<string> {
  const setting = await prisma.settings.findUnique({
    where: { key },
    select: { value: true },
  });

  return setting?.value ?? "example@email.com";
}
